import React from 'react'

import GeneralServices from '../../../app/service/generalServices'
import HandleErrorService from '../../../app/service/handleErrorService'

import * as popUp from '../../toastr'
import { InputNumber } from 'primereact/inputnumber'
import ConstantsUtil from '../../../context/constantsUtil'
import CustomCalendar from '../../calendar/customCalendar'
import TipoDePagamentoService from '../../../app/service/contasAPagar/tipoDePagamentoService'
import InputChooseTipoDePagamento from '../../contasAPagar/inputChooseTipoDePagamento'
import InputChooseTipoDeRecebimento from '../../tipoDeRecebimento/inputChooseTipoDeRecebimento'
import QuantidadeParcelasComponent from '../../contasAPagar/quantidadeParcelasComponent'
import ProvisaoService from '../../../app/service/contasAPagar/provisaoService'
import ProvisaoRecebimentoService from '../../../app/service/contasAReceber/provisaoRecebimentoService'
import TooltipButton from '../../tooltipButton'
import { Tooltip } from 'primereact/tooltip';
import CentralService from '../../../app/service/central/centralService'
import VisualizarDanfeButton from '../../nf/visualizarDanfeButton'
import ConfirmationDialog from '../../confirmationDialog'
import { FileUpload } from 'primereact/fileupload'
import AuthService from '../../../app/service/authService'
import InputsImpostosRetidosComponent from '../inputsImpostosRetidosComponent'
import { InputSwitch } from 'primereact/inputswitch'
import ProvisaoReplicacaoComponent from '../provisaoReplicacaoComponent'
import { Button } from 'primereact/button'
import InputChooseGrupoDePagamento from '../inputChooseGrupoDePagamento'
import InputChooseFornecedor from '../inputChooseFornecedor'
import SelectMenu from '../../selectMenu'
import TipoContaGerancialSelectMenu from '../../tipoContaGerancialSelectMenu'


const widthInput = '12rem'
class LancamentoProvisaoComponent extends React.Component {

    constructor(){
        super();
        this.generalServices = new GeneralServices();
        this.tipoDePagamentoService = new TipoDePagamentoService();
        this.provisaoService = new ProvisaoService();
        this.provisaoRecebimentoService = new ProvisaoRecebimentoService();
        this.centralService = new CentralService();

        this.dateInputRef = React.createRef()
        this.inputValorRef = React.createRef();
        this.historicoRef = React.createRef();
        this.fileUploadRef = React.createRef();
        this.inputChooseTipoDePagamentoRef = React.createRef();
        this.inputChooseTipoDeRecebimentoRef = React.createRef();


        this.quantidadeParcelasComponentRef = React.createRef();
        this.provisaoReplicacaoComponentRef = React.createRef()


    }

    state = {
        dataLancamento: '',
        dataLancamentoView: '',
        inputDateErrorClass:'',
        errorDateMessage:'',

        dataCompetenciaNfse: '',
        dataCompetenciaNfseView: '',
        inputDataCompetenciaNfseErrorClass:'',
        errorDataCompetenciaNfseMessage:'',

        tipoDePagamentoList: [],
        selectedTipoDePagamento: null,
        selectedTipoDePagamentoLabel: '',
        inputTipoDePagamentoErrorClass: '',
        loadingTipoDePagamentoTable: false,
        forceShowTipoDePagamentoDialog: false,
        forceTipoDePagamentoListInDialog: false,

        selectedTipoDeRecebimento: null,
        selectedTipoDeRecebimentoLabel: '',
        inputTipoDeRecebimentoErrorClass: '',

        numeroDocumento: '',
        inputNumeroDocumentoErrorClass: '',

        complementoHistorico: '',
        inputComplementoHistoricoErrorClass: '',
        errorComplementoHistoricoMessage: '',

        // valor: null,
        inputValorErrorClass: '',
        errorValorMessage: '',

        isSavingLancamentos: false,

        visibleConfirmDialog: false,
        lancamentoToSave: '',

        arquivoComprovantePagamento: null,

        possuiImpostosRetidos: false,
        valorBruto: null,
        impostoRetidoValorPIS: null,
        impostoRetidoValorCOFINS: null,
        impostoRetidoValorINSS: null,
        impostoRetidoValorIR: null,
        impostoRetidoValorCSLL: null,
        impostoRetidoValorISS: null,
        valorLiquido: null,

        displayConfirmDeleteDialog: false,

        tipoContaGerencial: ConstantsUtil.contaGerencialGeral,
        grupoDePagamentoEspecifico: null,
        inputGrupoDePagamentoEspecificoErrorClass: '',

    }

    componentDidMount(){
        if(this.props.provisao){
            this.preencheDadosProvisao()
        }
        if(this.props.initialTipoDePagamento){
            this.tipoDePagamentoService.searchById(this.props.initialTipoDePagamento.id)
            .then(response => {
                const tipoDePagamento = response.data
                this.setState({
                    selectedTipoDePagamento: tipoDePagamento,
                    selectedTipoDePagamentoLabel: tipoDePagamento.nome,
                })
            })
            .catch(error => HandleErrorService.handleError(error))
        }
        if(this.props.initialValor != null){
            this.setState({ valorLiquido: this.props.initialValor })
        }
    }

    isProvisaoNFSe = () => {
        return this.props.provisao && this.props.provisao.nfse && !GeneralServices.isEmptyObject(this.props.provisao.nfse)
    }

    preencheDadosProvisao = async () => {
        // console.log("preenche! ", this.props.provisao)
        let provisao = this.props.provisao
        
        this.setState({
            dataLancamento: provisao.dataLancamento,
            dataLancamentoView: provisao.dataLancamentoView,
            numeroDocumento: provisao.numeroDocumento
        })

        if(provisao.grupoDePagamentoEspecifico){
            this.setState({
                tipoContaGerencial: ConstantsUtil.contaGerencialEspecificaLancamento,
                grupoDePagamentoEspecifico: provisao.grupoDePagamentoEspecifico
            })
        }
        
        if(this.isProvisaoNFSe()){
            // console.log("provisao.nfse.dataCompetencia", provisao.nfse.dataCompetencia)
            // console.log("dataCompetenciaNfseView", this.state.dataCompetenciaNfseView)            
            this.setState({
                dataCompetenciaNfse: provisao.nfse.dataCompetencia,
                dataCompetenciaNfseView: GeneralServices.convertBrStringToJsDate(provisao.nfse.dataCompetencia),
            })
        }

        if(this.props.provisao.complementoHistorico){
            this.setState({complementoHistorico: this.props.provisao.complementoHistorico})
        }
        else if(provisao.historico){
            let historicoArray = provisao.historico.split(", ")
            if(historicoArray && historicoArray[1]){
                this.setState({complementoHistorico: historicoArray[1]})
            }
        }

        if(this.props.provisao.tipoDePagamento){
            this.handleSelectionTipoDePagamentoChange(provisao.tipoDePagamento, provisao.tipoDePagamento.nome)
        }

        if(this.props.provisao.tipoDeRecebimento){
            this.handleSelectionTipoDeRecebimentoChange(
                provisao.tipoDeRecebimento,
                provisao.tipoDeRecebimento.nomeTipoDeRecebimento
            )
        }

        const event = {
            target: {
                name: 'valorLiquido'
            },
            value: provisao.valorTotal
        }
        this.handleValorChange(event)

        if(this.props.insideEditDialog && this.props.provisao.possuiImpostosRetidos){
            await this.setState({
                possuiImpostosRetidos: true,
                impostoRetidoValorPIS: this.props.provisao.impostosRetidos.impostoRetidoValorPIS ? this.props.provisao.impostosRetidos.impostoRetidoValorPIS : 0.0,
                impostoRetidoValorCOFINS: this.props.provisao.impostosRetidos.impostoRetidoValorCOFINS ? this.props.provisao.impostosRetidos.impostoRetidoValorCOFINS : 0.0,
                impostoRetidoValorINSS: this.props.provisao.impostosRetidos.impostoRetidoValorINSS ? this.props.provisao.impostosRetidos.impostoRetidoValorINSS : 0.0,
                impostoRetidoValorIR: this.props.provisao.impostosRetidos.impostoRetidoValorIR ? this.props.provisao.impostosRetidos.impostoRetidoValorIR : 0.0,
                impostoRetidoValorCSLL: this.props.provisao.impostosRetidos.impostoRetidoValorCSLL ? this.props.provisao.impostosRetidos.impostoRetidoValorCSLL : 0.0,
                impostoRetidoValorISS: this.props.provisao.impostosRetidos.impostoRetidoValorISS ? this.props.provisao.impostosRetidos.impostoRetidoValorISS : 0.0,
            })
            this.setState({
                valorBruto:
                    this.state.valorLiquido
                    + this.state.impostoRetidoValorPIS
                    + this.state.impostoRetidoValorCOFINS
                    + this.state.impostoRetidoValorINSS
                    + this.state.impostoRetidoValorIR
                    + this.state.impostoRetidoValorCSLL
                    + this.state.impostoRetidoValorISS
            })
        }

    }

    handleChange = async (event) => {
        const value = event.target.value
        const name = event.target.name
        await this.setState({ [name]: value })
    }

    handleDateChange = async (event) => {

        const value = event.target.value
        const name = event.target.name
        await this.setState({ [name]: GeneralServices.convertJSDateToBrDate(value) })
        const nameView = name+"View"
        await this.setState({[nameView]: value })
        
        // console.log("value: ", value)
        // console.log("this.state.dataCompetenciaNfse", this.state.dataCompetenciaNfse)
        // console.log("this.state.dataCompetenciaNfseView", this.state.dataCompetenciaNfseView)

    }

    handleSelectionTipoDePagamentoChange = async (tipoDePagamento, label) => {

        if(!this.props.insideEditDialog){
            this.setaFormaDePagamentoFromTipoDePagamento(tipoDePagamento)
        }

        this.hideTipoDePagamentoDialog()

        if(this.props.unificar){
            if(!tipoDePagamento.chaveUnicaTipoDePagamento){
                popUp.infoPopUp("O Tipo de Pagamento selecionado não é unificado entre as empresas. Para utilizá-lo, faça login na empresa correspondente.")
                return;
            }
            this.buscaTipoDePagamentoCompletoPorChaveUnificada(tipoDePagamento.chaveUnicaTipoDePagamento)
            return;
        }

        await this.setState({selectedTipoDePagamento: tipoDePagamento})
        await this.setState({selectedTipoDePagamentoLabel: label})
        this.buscaTipoDePagamentoCompleto(tipoDePagamento.id)
    }

    handleSelectionTipoDeRecebimentoChange = async (tipoDeRecebimento, label) => {
        await this.setState({
            selectedTipoDeRecebimento: tipoDeRecebimento,
            selectedTipoDeRecebimentoLabel: label,
            inputTipoDeRecebimentoErrorClass: ''
        })
    }

    buscaTipoDePagamentoCompleto = (tipoDePagamentoId) => {
        this.tipoDePagamentoService.searchById(tipoDePagamentoId)
        .then(response => {
            let selectedTipoDePagamento = response.data
            this.setState({selectedTipoDePagamento})
        })
        .catch(error => {
            HandleErrorService.handleError(error)
        })
    }

    buscaTipoDePagamentoCompletoPorChaveUnificada = (chaveUnicaTipoDePagamento) => {
        this.tipoDePagamentoService.searchByChaveUnificada(chaveUnicaTipoDePagamento)
        .then(response => {
            let selectedTipoDePagamento = response.data
            this.setState({selectedTipoDePagamento})
        })
        .catch(error => {
            HandleErrorService.handleError(error)
        })
    }

    getGrupoDePagamentoLabel = () => {

        if(this.props.insideEditDialog){

            //Dialog de editar provisão, seja manual, de NFSe ou de NFe

            if(this.state.tipoContaGerencial === ConstantsUtil.contaGerencialEspecificaLancamento){
                return this.state.grupoDePagamentoEspecifico ? this.state.grupoDePagamentoEspecifico.nome : ''
            }

            if(this.state.selectedTipoDePagamento && this.state.selectedTipoDePagamento.grupoDePagamento && this.state.selectedTipoDePagamento.grupoDePagamento.nome){
                return this.state.selectedTipoDePagamento.grupoDePagamento.nome
            }
            return this.props.provisao && this.props.provisao.grupoDePagamento ? this.props.provisao.grupoDePagamento.nome : ''
        }

        //Tela de lançamento manual
        else if(this.state.tipoContaGerencial === ConstantsUtil.contaGerencialEspecificaLancamento){
            return this.state.grupoDePagamentoEspecifico ? this.state.grupoDePagamentoEspecifico.nome : ''
        }
        else {
            //Tela de lançamento manual de provisão.
            return this.state.selectedTipoDePagamento && this.state.selectedTipoDePagamento.grupoDePagamento ? this.state.selectedTipoDePagamento.grupoDePagamento.nome : ''
        }
    }

    getNomeFornecedor = () => {
        // console.log("this.props.provisao: ", this.props.provisao)
        if(this.props.provisao.nfse){
            return this.props.provisao.nfse.prestadorServico.nome
        }
        else if(this.props.provisao.notaFiscal){
            return this.props.provisao.notaFiscal.fornecedor.nome
        }
        return ""
    }

    handleSelectionGrupoDePagamentoChange = (grupoDePagamento) => {
        // console.log("handleSelectionGrupoDePagamentoChange", grupoDePagamento)
        // console.log("handleSelectionGrupoDePagamentoChange tipoDePagamento", this.state.selectedTipoDePagamento)
        
        if(this.state.tipoContaGerencial === ConstantsUtil.contaGerencialEspecificaLancamento){
            this.setState({grupoDePagamentoEspecifico: grupoDePagamento})
            return
        }

        let tipoDePagamentoToEditGrupo = null

        if(!this.props.insideEditDialog){
            // Tela de lançamento manual de provisão
            tipoDePagamentoToEditGrupo = JSON.parse(JSON.stringify(this.state.selectedTipoDePagamento))
            tipoDePagamentoToEditGrupo.grupoDePagamento = JSON.parse(JSON.stringify(grupoDePagamento))
        }

        AuthService.startBlockUi()
        this.resolveSelectionGrupoDePagamentoChange(tipoDePagamentoToEditGrupo, grupoDePagamento)
        .then(response => {
            popUp.successPopUp("Conta Gerencial atualizada com sucesso!")
            this.research()
            if(tipoDePagamentoToEditGrupo){
                this.setState({selectedTipoDePagamento: tipoDePagamentoToEditGrupo})
            }
        })
        .catch(error => {
            HandleErrorService.handleError(error)
        })
        .finally(() => {
            AuthService.stopBlockUi()
        })   

    }

    resolveSelectionGrupoDePagamentoChange = (tipoDePagamentoToEditGrupo, grupoDePagamento) => {
        
        if(!this.props.insideEditDialog){
            // Tela de lançamento manual de provisão
            return this.tipoDePagamentoService.update(tipoDePagamentoToEditGrupo)
        }
        else{
            //Tela de edição de provisão
            return this.provisaoService.atualizaGrupoDePagamentoFromProvisao(this.props.provisao, grupoDePagamento)
        }

    }

    setaFormaDePagamentoFromTipoDePagamento = (tipoDePagamento) => {
        this.tipoDePagamentoService.buscaFormaDePagamentoSalva(tipoDePagamento.id)
        .then(response => {
            if(response.data){
                this.quantidadeParcelasComponentRef.current.setFormaDePagamento(response.data)
            }
        })
        .catch(error => {
            HandleErrorService.handleError(error)
        })        
    }

    handleValorChange = (event) => {
        // console.log("event: ", event)
        let value = event.value
        if(value === 0){
            value = null
        }
        const name = event.target.name
        this.setState({ [name]: value })
    }

    handleKeyPress = async e => {
        await this.generalServices.sleep(1) //essa função é chamada no mesmo instante que a handleValorChange.
                                            //Precisa esperar um tempo de forma que o valor seja alterado.
        //it triggers by pressing the enter key
        if (e.key === "Enter" && !this.state.isSavingLancamentos) {
            this.callSave();
        }
    }

    resetInputs = () => {

        this.setState({
            dataLancamento: '',
            dataLancamentoView: '',
            dataCompetenciaNfse: '',
            dataCompetenciaNfseView: '',
            selectedTipoDePagamento: '',
            selectedTipoDePagamentoLabel: '',
            selectedTipoDeRecebimento: '',
            selectedTipoDeRecebimentoLabel: '',
            numeroDocumento: '',
            complementoHistorico: '',
            valorLiquido: null,
            possuiImpostosRetidos: null,
            valorBruto: null,
            impostoRetidoValorPIS: null,
            impostoRetidoValorCOFINS: null,
            impostoRetidoValorINSS: null,
            impostoRetidoValorIR: null,
            impostoRetidoValorCSLL: null,
            impostoRetidoValorISS: null,
            tipoContaGerencial: ConstantsUtil.contaGerencialGeral,
            grupoDePagamentoEspecifico: null
        })

        if(this.inputChooseTipoDePagamentoRef.current){
            this.inputChooseTipoDePagamentoRef.current.clearSelectedTipoDePagamentoIdSimpleView()
        }

        if(this.inputChooseTipoDeRecebimentoRef.current){
            this.inputChooseTipoDeRecebimentoRef.current.clearSelectedTipoDeRecebimentoIdSimpleView()
        }

        this.onClearComprovantePagamento()

        if(this.quantidadeParcelasComponentRef.current){
            this.quantidadeParcelasComponentRef.current.reset()
        }
        if(this.provisaoReplicacaoComponentRef.current){
            this.provisaoReplicacaoComponentRef.current.reset()
        }

    }

    resetView = () => {

        this.setState({
            inputDateErrorClass: "",
            errorDateMessage: "",
            inputTipoDePagamentoErrorClass: '',
            inputTipoDeRecebimentoErrorClass: '',
            inputNumeroDocumentoErrorClass: '',
            inputValorErrorClass: "",
            errorValorMessage: "",
            inputGrupoDePagamentoEspecificoErrorClass: ''
        })

    }

    checkData = () => {
        var check = true

        if(!this.props.isRecorrencia && !this.state.dataLancamento){
            this.setState({inputDateErrorClass: ConstantsUtil.primereactInputErrorClass})
            this.setState({errorDateMessage: "Informe a data de competência"})
            check = false
        }

        if(this.isProvisaoNFSe() && !this.state.dataCompetenciaNfse){
            this.setState({inputDataCompetenciaNfseErrorClass: ConstantsUtil.primereactInputErrorClass})
            this.setState({errorDataCompetenciaNfseMessage: "Informe a data de competência"})
            check = false
        }

        if(this.props.isProvisaoAReceber && !this.state.selectedTipoDeRecebimento){
            this.setState({inputTipoDeRecebimentoErrorClass: ConstantsUtil.bootstrapInputErrorClass})
            check = false;
        }

        if(!this.props.isProvisaoAReceber && !this.state.selectedTipoDePagamento && ( !this.props.provisao || (!this.props.provisao.notaFiscal && !this.props.provisao.nfse) )){
            this.setState({inputTipoDePagamentoErrorClass: ConstantsUtil.bootstrapInputErrorClass})
            check = false;
        }

        // if(!this.state.numeroDocumento){
        //     this.setState({inputNumeroDocumentoErrorClass: ConstantsUtil.bootstrapInputErrorClass})
        //     check = false;
        // }

        if(!this.state.valorLiquido){
            this.setState({inputValorErrorClass: ConstantsUtil.primereactInputErrorClass})
            this.setState({errorValorMessage: "Informe o valor do lançamento"})
            check = false
        }

        if(
            !this.props.isProvisaoAReceber
            &&
            this.state.tipoContaGerencial === ConstantsUtil.contaGerencialEspecificaLancamento
            && !this.state.grupoDePagamentoEspecifico
        ){
            this.setState({inputGrupoDePagamentoEspecificoErrorClass: ConstantsUtil.bootstrapInputErrorClass})
            check = false
        }


        let checkProvisaoReplicacaoComponent = this.props.isRecorrencia ? this.provisaoReplicacaoComponentRef.current.checkData(true) : true

        let checkQuantidadeParcelasComponent = this.props.isRecorrencia ? true : this.quantidadeParcelasComponentRef.current.checkData().checkGeral

        let finalCheck = check && checkQuantidadeParcelasComponent && checkProvisaoReplicacaoComponent

        // console.log("finalCheck: ", finalCheck)
        
        return finalCheck
    }


    callSave = (uuidRecorrencia) => {

        // console.log(this.state.arquivoComprovantePagamento)

        // já tá salvando, ignora (evita duplo click / enter)
        if(this.state.isSavingLancamentos){
            return
        }

        this.resetView()
        if(this.checkData()){

            this.disableSaveButton()
            AuthService.startBlockUi()

            if(this.props.insideEditDialog){
                this.edit(uuidRecorrencia)
            }
            else if(this.props.isRecorrencia){
                this.saveRecorrencia()
            }
            else{
                this.checkDuplicateAndsave()
            }
        }
    }

    montaResultOject = () => {
        let resultObject = this.quantidadeParcelasComponentRef.current.getResultObject()
        resultObject.dataLancamento = this.state.dataLancamento
        resultObject.dataCompetenciaNfseFromEditProvisao = this.state.dataCompetenciaNfse
        resultObject.tipoDePagamento = this.props.isProvisaoAReceber ? null : this.state.selectedTipoDePagamento
        resultObject.tipoDeRecebimento = this.props.isProvisaoAReceber ? this.state.selectedTipoDeRecebimento : null
        resultObject.notaFiscal = this.props.provisao ? this.props.provisao.notaFiscal : null
        resultObject.nfse = this.props.provisao ? this.props.provisao.nfse : null
        resultObject.numeroDocumento = this.state.numeroDocumento ? this.state.numeroDocumento : ""
        resultObject.complementoHistorico = this.state.complementoHistorico
        resultObject.arquivoComprovantePagamento = this.state.arquivoComprovantePagamento

        if(!this.props.isProvisaoAReceber && this.state.tipoContaGerencial === ConstantsUtil.contaGerencialEspecificaLancamento){
            resultObject.grupoDePagamentoEspecifico = this.state.grupoDePagamentoEspecifico
        }

        if(this.state.possuiImpostosRetidos){
            resultObject.possuiImpostosRetidos = this.state.possuiImpostosRetidos
            resultObject.impostosRetidos = {
                impostoRetidoValorPIS: this.state.impostoRetidoValorPIS,
                impostoRetidoValorCOFINS: this.state.impostoRetidoValorCOFINS,
                impostoRetidoValorINSS: this.state.impostoRetidoValorINSS,
                impostoRetidoValorIR: this.state.impostoRetidoValorIR,
                impostoRetidoValorCSLL: this.state.impostoRetidoValorCSLL,
                impostoRetidoValorISS: this.state.impostoRetidoValorISS
            }
        }
        
        return resultObject
    }

    checkDuplicateAndsave = () => {

        let resultObject = this.montaResultOject()
        // console.log("checkDuplicateAndsave: ", resultObject)

        let resultObjectToCheckJaExiste = JSON.parse(JSON.stringify(resultObject))
        resultObjectToCheckJaExiste.arquivoComprovantePagamento = null
        // console.log("resultObject: ", resultObject)

        if(this.props.isProvisaoAPagar){

            this.provisaoService.jaExisteTipoDePagamentoAndNumeroDocumento(resultObjectToCheckJaExiste)
            .then(response => {
                if(response.data === true){
                    // libera a tela pro usuário responder o dialog. Botão continua desabilitado.
                    AuthService.stopBlockUi()
                    this.setState({
                        visibleConfirmDialog: true,
                        lancamentoToSave: resultObject,
                    })
                }
                else{
                    this.save(resultObject)
                }
            })
            .catch(error => {
                HandleErrorService.handleError(error)
                AuthService.stopBlockUi()
                this.enableSaveButton()
            })
        }
        else{

            this.provisaoRecebimentoService.jaExisteTipoDeRecebimentoAndNumeroDocumento(resultObjectToCheckJaExiste)
            .then(response => {
                if(response.data === true){
                    // libera a tela pro usuário responder o dialog. Botão continua desabilitado.
                    AuthService.stopBlockUi()
                    this.setState({
                        visibleConfirmDialog: true,
                        lancamentoToSave: resultObject,
                    })
                }
                else{
                    this.save(resultObject)
                }
            })
            .catch(error => {
                HandleErrorService.handleError(error)
                AuthService.stopBlockUi()
                this.enableSaveButton()
            })
        }
    }

    montaRecorrenciaResultOject = () => {
        let resultObject = {}
        resultObject.tipoDePagamento = this.state.selectedTipoDePagamento
        resultObject.complementoHistorico = this.state.complementoHistorico
        resultObject.valorTotal = this.state.valorLiquido
        resultObject.informacaoReplicacao = this.provisaoReplicacaoComponentRef.current.getResultObject()
        return resultObject

    }

    saveRecorrencia = () => {

        let resultObject = this.montaRecorrenciaResultOject()
        // console.log("resultObject: ", resultObject)
        this.provisaoService.createRecorrencia(resultObject)
        .then(response => {
            this.resetInputs()
            popUp.successPopUp("Provisão Lançada com Sucesso!")
        })
        .catch(error => {
            console.log("error: ", error)
            HandleErrorService.handleError(error)
        })
        .finally(() => {
            AuthService.stopBlockUi()
            this.enableSaveButton()
        })
    
    }

    save = (resultObject) => {

        AuthService.startBlockUi()

        const service = this.props.isProvisaoAReceber ? this.provisaoRecebimentoService : this.provisaoService

        service.save(resultObject)
        .then(response => {
            this.resetInputs()
            popUp.successPopUp("Provisão Lançada com Sucesso!")
            if (this.props.onSuccessLancamento) {
                this.props.onSuccessLancamento(response.data)
            }
        })
        .catch(error => {
            console.log("error: ", error)
            HandleErrorService.handleError(error)
        })
        .finally(() => {
            AuthService.stopBlockUi()
            this.enableSaveButton()
        })
    }

    handleEditProvisao = (resultObject) => {
        if(this.props.isProvisaoAReceber){
            return this.provisaoRecebimentoService.edit(resultObject)
        }
        if(this.props.empresa){
            /*
            Usuário está vendo unificado, portanto esta provisão pode ser de outra empresa.
            Deve chamar central para encaminhar ao worker corretamente.
            */
           return this.centralService.editProvisao(resultObject, this.props.empresa.id)

        }
        
        return this.provisaoService.edit(resultObject)
        
    }

    onSuccessEdit = () => {
        if(this.props.onSuccessEdit){
            this.props.onSuccessEdit()
        }
    }

    onCallEdit = () => {
        if(this.props.onCallEdit){
            this.props.onCallEdit()
        }
    }

    edit = (uuidRecorrencia) => {

        this.onCallEdit()
        
        let resultObject = this.montaResultOject()
        resultObject.id = this.props.provisao.id
        resultObject.uuidRecorrencia = uuidRecorrencia
        
        // console.log("edit: ", resultObject)
        this.handleEditProvisao(resultObject)
        .then(response => {
            popUp.successPopUp("Provisão Alterada com Sucesso!")
            this.onSuccessEdit()
        })
        .catch(error => {
            HandleErrorService.handleError(error)
            if(this.props.onErrorEdit){
                this.props.onErrorEdit()
            }
        })
        .finally(() => {
            AuthService.stopBlockUi()
            this.enableSaveButton()
        })
    }

    disableSaveButton = () => {
        this.setState({isSavingLancamentos: true})
        if(this.props.disableSaveButton){
            this.props.disableSaveButton()
        }
    }

    enableSaveButton = () => {
        this.setState({isSavingLancamentos: false})
        if(this.props.enableSaveButton){
            this.props.enableSaveButton()
        }
    }

    hideTipoDePagamentoDialog = () => {
        this.setState({forceShowTipoDePagamentoDialog: false})
    }

    isProvisaoFromNFOuNFse = () => {
        return this.props.provisao && (this.props.provisao.notaFiscal || this.props.provisao.nfse)
    }

    closeConfirmDialog = () => {
        this.setState({
            visibleConfirmDialog: false,
            lancamentoToSave: ''
        })
    }

    // usuário cancelou no dialog de duplicidade, então libera o botão
    cancelConfirmDialog = () => {
        this.closeConfirmDialog()
        this.enableSaveButton()
    }

    onSelectComprovantePagamento = (event) => {
        // console.log("onSelectComprovantePagamento: ", this.fileUploadRef.current.state.files)
        // console.log("onSelectComprovantePagamento: ", event)
        const file = event.files[0]; // primeiro arquivo selecionado
        if (!file) return;
        // console.log("filename: ", file.name)
        // const extensao = file.name.split('.').pop().toLowerCase();
        // console.log("Extensão:", extensao);

        //Define a função onload que será usada dentro de readAsDataURL em GeneralServices.transformaAquivoEmBase64.
        let onloadFunction = (reader) => {
            const arquivoBase64 = reader.result.split(',')[1]; 
            // console.log('Base64 do arquivo:', base64);
            
            this.setState({
                arquivoComprovantePagamento: {
                    nomeArquivoComExtensao: file.name,
                    arquivoBase64
                }
            })

        };

        GeneralServices.transformaAquivoEmBase64(file, onloadFunction)

    };

    onClearComprovantePagamento = () => {
        if (this.fileUploadRef.current) {
            this.fileUploadRef.current.clear();
        }
        this.setState({arquivoComprovantePagamento: null})
    }

    getIdComponenteDigital = () => {
        
        if(this.props.provisao && this.props.provisao.arquivoComprovantePagamento){
            return this.props.provisao.arquivoComprovantePagamento.id
        }

        if(this.props.provisao && this.props.provisao.notaFiscal && this.props.provisao.notaFiscal.chave){
            return this.props.provisao.notaFiscal.chave
        }

        if(this.props.provisao && this.props.provisao.nfse && this.props.provisao.nfse.codigoVerificacao){
            return this.props.provisao.nfse.codigoVerificacao
        }

        return null

    }

    getPossuiComponenteDigital = () => {
        // console.log("getPossuiComponenteDigital: ", this.props.provisao)
        if(this.props.provisao && this.props.provisao.arquivoComprovantePagamento){
            return true
        }

        if(this.props.provisao && this.props.provisao.notaFiscal && this.props.provisao.notaFiscal.possuiDanfe){
            return true
        }

        if(this.props.provisao && this.props.provisao.nfse && this.props.provisao.nfse.possuiPdf){
            return true
        }

        return false
    }

    getTipoComponenteDigital = () => {

        if(this.props.provisao && this.props.provisao.arquivoComprovantePagamento){
            return ConstantsUtil.tipoComponenteDigitalComprovanteProvisaoManual
        }

        if(this.props.provisao && this.props.provisao.notaFiscal && this.props.provisao.notaFiscal.chave){
            return ConstantsUtil.tipoComponenteDigitalDanfeNF
        }

        if(this.props.provisao && this.props.provisao.nfse && this.props.provisao.nfse.codigoVerificacao){
            return ConstantsUtil.tipoComponenteDigitalPdfNfse
        }

        return ''
    }

    handleImpostoRetidoChange = async (event) => {
        const name = event.target.name
        let previousValue = this.state[name]

        await this.setState({ [name]: event.value })
        
        let valorLiquido =
            this.state.valorBruto
            - this.state.impostoRetidoValorPIS
            - this.state.impostoRetidoValorCOFINS
            - this.state.impostoRetidoValorINSS
            - this.state.impostoRetidoValorIR
            - this.state.impostoRetidoValorCSLL
            - this.state.impostoRetidoValorISS

        if(valorLiquido < 0){
            await this.setState({ [name]: previousValue })
            popUp.infoPopUp("Valor dos Impostos Retidos ultrapassou Valor Bruto.")
            return;
        }

        this.setState({valorLiquido})
    }

    handleChangePossuiImpostosRetidos = event => {
        let estadoAnterior = this.state.possuiImpostosRetidos
        let estadoAtual = event.value

        if(!estadoAnterior && estadoAtual){
            //Clicou para habilitar impostos retidos
            this.setState({
                valorBruto: this.state.valorLiquido,
                valorLiquido: null
            })
        }
        else if(estadoAnterior && !estadoAtual){
            //Clicou para desabilitar impostos retidos
            this.setState({
                valorLiquido: this.state.valorBruto,
                valorBruto: null,
                impostoRetidoValorPIS: null,
                impostoRetidoValorCOFINS: null,
                impostoRetidoValorINSS: null,
                impostoRetidoValorIR: null,
                impostoRetidoValorCSLL: null,
                impostoRetidoValorISS: null,                

            })
        }

        this.setState({
            possuiImpostosRetidos: event.value,
            // valorLiquido: null
        })
    }

    research = () => {
        if(this.props.research){
            this.props.research()
        }
    }

    confirmDeleteProvisao = () => {
        // console.log("provisao to delete: ", this.props.provisao)
        AuthService.startBlockUi()
        this.setState({displayConfirmDeleteDialog: false})

        const service = this.props.isProvisaoAReceber ? this.provisaoRecebimentoService : this.provisaoService

        service.deleteById(this.props.provisao.id)
        .then(response => {
            popUp.successPopUp("Provisão deletada com sucesso!")
            this.onCallEdit()
            this.onSuccessEdit()
        })
        .catch(error => {
            HandleErrorService.handleError(error)
        })
        .finally(() => {
            AuthService.stopBlockUi()
        })
    }

    render() {


        const anexarComprovanteButton = {
            label: 'Anexar Comprovante',
            icon: "pi pi-file-pdf",
            className: 'basic-upload-button p-button-danger',
        };

        const renderConfirmationDialog = () => {
            return (
                <ConfirmationDialog
                    header="Lançar Provisão"
                    width={'70%'}
                    confimationMessage="Já existe lançamento com mesmo Número e mesmo Tipo de Pagamento. Deseja continuar?"
                    visible={this.state.visibleConfirmDialog}
                    confirm={() => {
                        // só fecha, quem habilita o botão é o finally do save
                        this.save(this.state.lancamentoToSave)
                        this.closeConfirmDialog()
                    }}
                    hide={this.cancelConfirmDialog}
                />
            )
        }
        
        const renderTipoDePagamentoInput = () => {
            if( this.props.isLancamento || (this.props.provisao && this.props.provisao.tipoDePagamento) ){

                // console.log("this.props.provisao.tipoDePagamento: ", this.props.provisao.tipoDePagamento)
                return (
                    <>
                        <div className='col-md-3'>
                            <InputChooseTipoDePagamento
                                ref={this.inputChooseTipoDePagamentoRef}
                                noHTMLFormat
                                selectedTipoDePagamentoLabel={this.state.selectedTipoDePagamentoLabel}
                                selectedTipoDePagamento={this.state.selectedTipoDePagamento}
                                simpleView
                                enableCadastrarButtonInSimpleView
                                forceShowDialog={this.state.forceShowTipoDePagamentoDialog}
                                hideDialog={this.hideTipoDePagamentoDialog}
                                tipoDePagamentoList={this.state.tipoDePagamentoList}
                                forceUpdate={this.state.forceTipoDePagamentoListInDialog}
                                doneForceUpdate={() => this.setState({forceTipoDePagamentoListInDialog: false})}
                                handleSelectionTipoDePagamentoChange={this.handleSelectionTipoDePagamentoChange}
                                error={this.state.inputTipoDePagamentoErrorClass}
                                provisoesAPagar
                                disabled={this.props.disablePrefilledFields}
                            />
                        </div>
                    </>
                        
                )
            }
        }

        const renderTipoDeRecebimentoInput = () => {
            if(this.props.isProvisaoAReceber){
                return (
                    <>
                        <div className='col-md-3'>
                            <InputChooseTipoDeRecebimento
                                ref={this.inputChooseTipoDeRecebimentoRef}
                                noHTMLFormat
                                simpleView
                                enableCadastrarButtonInSimpleView
                                selectedTipoDeRecebimento={this.state.selectedTipoDeRecebimento}
                                selectedTipoDeRecebimentoLabel={this.state.selectedTipoDeRecebimentoLabel}
                                handleSelectionTipoDeRecebimentoChange={this.handleSelectionTipoDeRecebimentoChange}
                                inputTipoDeRecebimentoErrorClass={this.state.inputTipoDeRecebimentoErrorClass}
                                error={this.state.inputTipoDeRecebimentoErrorClass}
                                disabled={this.props.disablePrefilledFields}
                            />
                        </div>
                    </>
                )
            }
        }

        const renderTipoDePagamentoOuRecebimentoInput = () => {
            if(this.props.isProvisaoAReceber){
                return renderTipoDeRecebimentoInput()
            }

            return renderTipoDePagamentoInput()
        }

        const renderGrupoDePagamentoInput = () => {
            if(this.props.isProvisaoAReceber || this.props.provisaoRecebimento){
                return
            }

            // console.log("this.props.provisao: ", this.props.provisao)
            if(
                !this.props.insideEditDialog
                || this.props.provisao.origem !== ConstantsUtil.origemProvisaoImportacaoNF
            )
            return (
                <>
                    <div className="col-md-2">
                        <TipoContaGerancialSelectMenu
                            label={"Tipo de Conta Gerencial"}
                            name="tipoContaGerencial"
                            value={this.state.tipoContaGerencial}
                            onChange={(event) => {
                                this.setState({grupoDePagamentoEspecifico: null})
                                this.handleChange(event)
                            }}
                        />
                    </div>

                    <div className='col-md-2'>
                    <InputChooseGrupoDePagamento
                        header="Conta Gerencial (DRE)"
                        noHTMLFormat
                        selectedGrupoDePagamentoLabel={this.getGrupoDePagamentoLabel()}
                        handleSelectionGrupoDePagamentoChange={this.handleSelectionGrupoDePagamentoChange}
                        inputGrupoDePagamentoErrorClass={this.state.inputGrupoDePagamentoEspecificoErrorClass}
                    />
                    </div>
                </>
            )
        }

        const renderFornecedorInput = () => {
            if(this.props.isProvisaoAReceber){
                return
            }

            // if(this.props.insideEditDialog && this.props.provisao.origem !== ConstantsUtil.origemProvisao){
            // let provisaoManualTipoDePagamentoSemFornecedor = this.props.provisao.tipoDePagamento && this.props.provisao.tipoDePagamento.natureza === this.tipoDePagamentoService.naturezaOutrosValue
            // console.log("provisaoManualTipoDePagamentoSemFornecedor: ", provisaoManualTipoDePagamentoSemFornecedor)
            if(this.props.insideEditDialog && !this.props.provisao.tipoDePagamento){
                return (
                    <div className = "col-md-3">
                        <InputChooseFornecedor
                            noHTMLFormat
                            selectedFornecedorLabel={this.getNomeFornecedor()}
                            disabled
                            // handleSelectionFornecedorChange={this.handleSelectionFornecedorChange}
                            // inputFornecedorErrorClass={this.state.inputFornecedorErrorClass}
                            // handleNewFornecedorCadastrado={this.props.handleNewFornecedorCadastrado}
                        />
                    </div>
                )
            }
        }

        const renderViewComponenteDigitalButton = () => {
            if(this.getPossuiComponenteDigital())
            return (
                <div
                    className="col-md-1"
                    style={{marginTop: '30px'}}
                >
                    <VisualizarDanfeButton
                        idComponenteDigital={this.getIdComponenteDigital()}
                        possuiArquivo={this.getPossuiComponenteDigital()}
                        tipo={this.getTipoComponenteDigital()}
                    />                        
                </div>
            )
        }

        const renderExcluirButton = () => {

            if(AuthService.getPerfil().isAlmoxarife){
                return <></>
            }            

            if(this.props.insideEditDialog){
                return (
                <>
                
                    <div className='col-md'>
                    <div className='right-align'>
                        <Button
                            className="p-button-danger"
                            label="Excluir"
                            icon="pi pi-trash"
                            style={{maxWidth: '200px'}}
                            onClick={() => this.setState({displayConfirmDeleteDialog: true})}
                        />
                    </div>
                    </div>
                    <br />
                </>
                )
            }
        }

        const renderConfirmDeleteProvisaoDialog = () => {
            return(
                <ConfirmationDialog
                    visible={this.state.displayConfirmDeleteDialog}
                    header={"Deletar Lançamento de Provisão"}
                    confimationMessage={ "Deseja Confirmar?"}
                    confirm={this.confirmDeleteProvisao}
                    hide={() => this.setState({displayConfirmDeleteDialog: false})}
                />
            )
        }        

        const renderNotaFiscalLabel = () => {
            if(
                this.props.provisao && this.props.provisao.notaFiscal
            ){
                return (
                    <div className="row">

                        <div className="col-md-10">
                            <label htmlFor="date">N° Nota Fiscal</label>
                            <input
                                type="text"
                                className={"form-control " + this.state.inputNumeroDocumentoErrorClass}
                                value = {this.props.provisao.notaFiscal.numero}
                                disabled
                            />
                        </div>

                    </div>
                )
            }
        }

        const renderComposicaoValorProvisaoInfo = () => {
            if(this.props.provisao && (this.props.provisao.notaFiscal || this.props.provisao.nfse)){
                // console.log("this.props.provisao.notaFiscal: ", this.props.provisao.notaFiscal)

                let isNfse = this.props.provisao.nfse

                let notaFiscal = isNfse ? this.props.provisao.nfse : this.props.provisao.notaFiscal
                if(isNfse){
                    notaFiscal.valorTotal = this.props.provisao.nfse.valorLiquido
                }

                if(!notaFiscal.valorDescontoPorBonificacao){
                    notaFiscal.valorDescontoPorBonificacao = 0.0
                }

                if(!notaFiscal.valorDescontoPorDevolucao){
                    notaFiscal.valorDescontoPorDevolucao = 0.0
                }

                let valorNotaFiscalInfo = `Valor da Nota Fiscal: ${GeneralServices.formatTo2CasasDecimais(notaFiscal.valorTotal)} (+)`

                let isAcrescimo = notaFiscal.valorAcrescimoDesconto > 0
                let valorAcrescimoDesconto = `Valor de ${isAcrescimo ? 'Acréscimo' : 'Desconto'}: ${Math.abs(GeneralServices.formatTo2CasasDecimais(notaFiscal.valorAcrescimoDesconto))} (${isAcrescimo ? '+' : '-'})`
                
                let valorBonificacao = `Valor da Bonificação: ${GeneralServices.formatTo2CasasDecimais(notaFiscal.valorDescontoPorBonificacao)} (-)`
                let valorDevolucao = `Valor da Devolução: ${GeneralServices.formatTo2CasasDecimais(notaFiscal.valorDescontoPorDevolucao)} (-)`

                let valorFinal = `Valor Final: ${GeneralServices.formatTo2CasasDecimais(notaFiscal.valorTotal + notaFiscal.valorAcrescimoDesconto - notaFiscal.valorDescontoPorBonificacao - notaFiscal.valorDescontoPorDevolucao)} (=)`
                
                let messageInfo = `Composição do Valor Final da Provisão:
                    ${valorNotaFiscalInfo}
                    ${valorAcrescimoDesconto}`
                if(!isNfse){
                    messageInfo = `${messageInfo}
                    ${valorBonificacao}
                    ${valorDevolucao}`
                }

                messageInfo = `${messageInfo}
                    ${valorFinal}`

                return (
                    <TooltipButton
                        tooltip={messageInfo}
                        tooltipOptions={{
                            className: 'custom-tooltip',
                            position: 'right'
                        }}
                        icon={<i className="pi pi-question" style={{fontSize: '0.8em'}}></i>}
                        style ={{maxHeight: '25px', maxWidth: '25px', marginLeft: '0.5em', marginBottom: '0.3em'}}
                        className="p-button-rounded p-mr-2"
                    />  
                )
            }
        }

        const renderAnexarComprovanteButton = () => {
            if(
                AuthService.verificaConfiguracao(ConstantsUtil.ARMAZENA_COMPROVANTE_PROVISAO)
                && !this.getPossuiComponenteDigital()
                && !this.isProvisaoFromNFOuNFse()
                && !this.props.isRecorrencia
            ){
                return (
                    <>
                        <FileUpload
                            ref={this.fileUploadRef}
                            name="file[]"
                            style={{maxHeight: '5px'}}
                            chooseOptions={anexarComprovanteButton}
                            mode="basic"
                            accept=".pdf, .zip"
                            className="upload-comprovante-pagamento"
                            customUpload
                            onSelect={this.onSelectComprovantePagamento}
                            uploadHandler={this.onClearComprovantePagamento}
                        />
                        <Tooltip
                            target=".upload-comprovante-pagamento .p-button"
                            content="Selecione um arquivo PDF ou ZIP"
                            position="top"
                            mouseTrack
                            mouseTrackTop={15}
                        />
                    </>
                )
            }
        }

        const rendeImpostosRetidos = () => {
            if(this.state.possuiImpostosRetidos) {
                return (
                    <>
                        <br />

                        {/* <div className='col-md-12'> */}
                        <div className='row'>

                        <InputsImpostosRetidosComponent
                            valorBruto={this.state.valorBruto}
                            valorPis={this.state.impostoRetidoValorPIS}
                            valorCofins={this.state.impostoRetidoValorCOFINS}
                            valorInss={this.state.impostoRetidoValorINSS}
                            valorIr={this.state.impostoRetidoValorIR}
                            valorCsll={this.state.impostoRetidoValorCSLL}
                            valorIss={this.state.impostoRetidoValorISS}
                            valorLiquido={this.state.valorLiquido}
                            handleChange={this.handleImpostoRetidoChange}
                            disabled={
                                false
                                // this.props.insideEditDialog
                                // && this.props.provisao.nfse
                                // && !GeneralServices.isEmptyObject(this.props.provisao.nfse)
                            }
                        />

                        </div>
                        {/* </div> */}
                    </>
                )
            }
        }        

        const renderValorTotal = () => {
            if(!this.state.possuiImpostosRetidos)
            return (
                <>
                    <br />

                    <div className="row">
                        <div className="col-md-2">
                            <div className='row'>
                            <div className="col-md-6">
                                <label style={{ display: 'block' }}> {`Valor ${this.props.isRecorrencia ? " Base" : "Total"}`} </label>
                            </div>
                            <div className="col-md-6">
                                {renderComposicaoValorProvisaoInfo()}
                            </div>
                            </div>
                            <InputNumber 
                                ref={this.inputValorRef}
                                inputStyle={{ width: widthInput }}
                                className={this.state.inputValorErrorClass}
                                name="valorLiquido"
                                inputId="valorFechamentoBancario"
                                value={this.state.valorLiquido}
                                onValueChange={this.handleValorChange}
                                onKeyDown={this.handleKeyPress}
                                mode="decimal" locale="pt-BR" minFractionDigits={2}
                                disabled={this.isProvisaoFromNFOuNFse() || this.props.disablePrefilledFields}
                            />
                        </div>

                        {renderAnexarComprovanteButton()}

                    </div>
                    <div className="row">
                        <div className="col-md-12">
                        <small id="valorError" className="p-error">{this.state.errorValorMessage}</small>
                        </div>
                    </div>                
                </>
            )
        }

        const renderDataCompetencia = () => {
            if(this.isProvisaoNFSe()){
                return (
                    <CustomCalendar
                        label="Data de Competência"
                        inputDateErrorClass={this.state.inputDataCompetenciaNfseErrorClass}
                        value={this.state.dataCompetenciaNfseView}
                        name="dataCompetenciaNfse"
                        onChange={this.handleDateChange}
                        errorDateMessage={this.state.errorDataCompetenciaNfseMessage}
                    />
                )
            }
        }

        const renderDataLancamento = () => {
            if(!this.props.isRecorrencia){
                return (
                    <CustomCalendar
                        ref={this.dateInputRef}
                        id="dataLancamentoFechamentoCaixa"
                        label="Data de Competência"
                        inputDateErrorClass={this.state.inputDateErrorClass}
                        value={this.state.dataLancamentoView}
                        name="dataLancamento"
                        onChange={this.handleDateChange}
                        errorDateMessage={this.state.errorDateMessage}
                        // disabled={this.isProvisaoFromNFOuNFse()}
                        disabled={this.isProvisaoNFSe()}
                    />
                )
            }
        }

        const renderNumeroDocumento = () => {
            if(!this.props.isRecorrencia){
                return (
                    <div className="col-md-2">
                        <label htmlFor="date">N° do Documento</label>
                        <input
                            type="text"
                            className={"form-control " + this.state.inputNumeroDocumentoErrorClass}
                            style={{ width: widthInput }}
                            value = {this.state.numeroDocumento}
                            name="numeroDocumento"
                            onChange={this.handleChange}
                            id="nomeTipoDeRecebimento"
                            disabled={this.isProvisaoFromNFOuNFse()}
                        />
                        <div className="invalid-feedback">Preencha</div>
                    </div>                    
                )
            }
        }

        const renderPossuiImpostosRetidosSwitchButton = () => {
            if(this.props.isRecorrencia || this.props.isProvisaoAPagar){
                return (
                    <>
                    <br />
                    <h6>Possui Impostos Retidos?</h6>
                    <InputSwitch
                        checked={this.state.possuiImpostosRetidos}
                        onChange={this.handleChangePossuiImpostosRetidos}
                        disabled={
                            this.props.insideEditDialog
                            && (
                                // (this.props.provisao.nfse && !GeneralServices.isEmptyObject(this.props.provisao.nfse)) ||
                                (this.props.provisao.notaFiscal && !GeneralServices.isEmptyObject(this.props.provisao.notaFiscal))
                            )
                        }
                    />                    
                    </>
                )
            }
        }

        const renderQuantidadeParcelasComponent = () => {
            if(!this.props.isRecorrencia){
                const initialPagamentoList = this.props.disablePrefilledFields && this.props.initialDataParcela
                    ? [{
                        parcela: 1,
                        data: this.props.initialDataParcela,
                        dataView: GeneralServices.convertBrStringToJsDate(this.props.initialDataParcela),
                        valor: this.props.initialValor,
                        inputDateErrorClass: '',
                        inputValorErrorClass: '',
                    }]
                    : undefined

                return (
                    <QuantidadeParcelasComponent
                        ref={this.quantidadeParcelasComponentRef}
                        valorTotalProvisao={this.state.valorLiquido}
                        provisao={this.props.provisao}
                        disabled={this.props.disablePrefilledFields || this.props.disabled}
                        isVisualizacaoProvisao
                        insideEditDialog={this.props.insideEditDialog}
                        research={this.research}
                        reRenderEditDialog={this.props.reRenderEditDialog}
                        insideDre={this.props.insideDre}
                        unificar={this.props.unificar}
                        hideFormaDePagamento={this.props.isProvisaoAReceber}
                        hideAcrescimoDesconto={this.props.isProvisaoAReceber}
                        qtdParcelas={this.props.disablePrefilledFields ? 1 : undefined}
                        initialPagamentoList={initialPagamentoList}
                    />
                )
            }
        }

        const renderProvisaoReplicacaoComponent = () => {
            if(this.props.isRecorrencia){
                return (
                    <ProvisaoReplicacaoComponent
                        ref={this.provisaoReplicacaoComponentRef}
                        valorPagamento={this.state.valorLiquido}
                    />
                )
            }
        }



        return (
            <>
                {renderExcluirButton()}

                <div className="row">
                
                    {renderDataLancamento()}

                    {renderDataCompetencia()}

                    {renderTipoDePagamentoOuRecebimentoInput()}

                    {renderNotaFiscalLabel()}

                    {renderViewComponenteDigitalButton()}

                    {renderFornecedorInput()}

                    {renderGrupoDePagamentoInput()}

                    {renderConfirmDeleteProvisaoDialog()}

                </div>

                    <br />

                    <div className="row">

                    {renderNumeroDocumento()}

                    <div className="col-md-3">
                    <label htmlFor="icon">Complemento de Histórico (Opcional)</label>
                        <input
                            type="text"
                            className={"form-control "}
                            value = {this.state.complementoHistorico}
                            name="complementoHistorico"
                            onChange={this.handleChange}
                            disabled={this.props.disabled}
                        />
                        <div className="invalid-feedback">Preencha</div>                        
                    </div>


                    </div>

                    {renderPossuiImpostosRetidosSwitchButton()}

                    {renderValorTotal()}

                    {rendeImpostosRetidos()}

                    <br />

                    {renderQuantidadeParcelasComponent()}

                    {renderProvisaoReplicacaoComponent()}

                    {renderConfirmationDialog()}


            <div className="d-flex "/>

        </>
        )

    }

}

export default LancamentoProvisaoComponent
